import { render, staticRenderFns } from "./Setup.vue?vue&type=template&id=04a5c27d"
import script from "./Setup.vue?vue&type=script&lang=ts"
export * from "./Setup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports